import { faker } from '@faker-js/faker';
import {
  cleanup,
  fireEvent,
  render,
  screen,
  waitFor,
} from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';
import React from 'react';

import constants from './constants';
import CustomerGroupSelectorContainer from './customer-group-selector';
import redux from './redux';
import factory from './redux/api/factory';
import translations from './translations';

translations.init();

function TestComponent() {
  return (
    <CustomerGroupSelectorContainer customerServiceUrl={faker.internet.url()} />
  );
}

describe('customer group selector loading success', () => {
  // create a mock server
  const server = setupServer(
    http.get(constants.endpoints.get.hierarchySummary, () => {
      return HttpResponse.json(
        factory.buildList(faker.number.int({ max: 10, min: 1 })),
      );
    }),
    http.get(constants.endpoints.get.context, () => {
      return HttpResponse.json({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
        enforce: 'customer_group',
        partner_uuid: faker.string.uuid(),
      });
    }),
    http.get(constants.endpoints.put.context, () => {
      return HttpResponse.json({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
        enforce: 'customer_group',
        partner_uuid: faker.string.uuid(),
      });
    }),
  );

  beforeAll(() => {
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    vi.restoreAllMocks();
    cleanup();
  });

  it('should render the customer group selector container', async () => {
    redux.store.dispatch(redux.api.getData());

    render(<TestComponent />);

    await waitFor(() => {
      expect(redux.store.getState().api.isLoading).toStrictEqual(false);
    });

    const openButton = screen.getByTestId('group-switcher-wrapper');
    expect(openButton).toBeDefined();
    const openSpy = vi.spyOn(redux.modal, 'open');
    fireEvent.click(openButton);
    expect(openSpy).toHaveBeenCalledTimes(1);

    await waitFor(() => {
      expect(
        screen.getAllByTestId('group-switcher-item').length,
      ).toBeGreaterThan(0);
    });

    const closeButton = screen.getAllByTestId('group-switcher-item')[0];
    expect(closeButton).toBeDefined();
    const closeSpy = vi.spyOn(redux.modal, 'close');
    fireEvent.click(closeButton);
    expect(closeSpy).toHaveBeenCalledTimes(1);
  });
});
